import {createReducer, on} from '@ngrx/store';
import * as CollectionItemActions from './collection-item.actions';
import {CollectionItem} from '../collection-item.model';

export interface CollectionItemState {
  detail?: CollectionItem;
}

export const collectionItemFeatureKey = 'collectionItem';
export const initialState: CollectionItemState = {};
export const collectionItemReducer = createReducer(
  initialState,
  on(CollectionItemActions.loadCollectionItem, (state) => ({
    ...state,
    detail: undefined,
  })),
  on(CollectionItemActions.loadCollectionItemSuccess, (state, {collectionItem}) => ({
    ...state,
    detail: collectionItem
  })),
  on(CollectionItemActions.loadCollectionItemError, (state) => ({...state, detail: undefined})),
  on(CollectionItemActions.loadCollectionItemError, (state) => ({
    ...state, detail: undefined
  })),

  on(CollectionItemActions.verifyWarrantySuccess, (state) => ({
    ...state,
  })),

  on(CollectionItemActions.extendWarrantySuccess, (state) => ({
    ...state,
  })),
);

